/** Presentation only: opaque router entry keys, numbers and bounded enum UI state. */
export type GalleryView = { filter: string; limit: number };
type Entry = { scrollY?: number; gallery?: GalleryView };
const entries = new Map<string, Entry>();
const MAX_ENTRIES = 30;
export function readPublicHistory(key: string): Entry | undefined { return entries.get(key); }
export function savePublicHistory(key: string, patch: Entry): void {
  const next = { ...entries.get(key), ...patch };
  entries.delete(key); entries.set(key, next);
  while (entries.size > MAX_ENTRIES) {
    const oldest = entries.keys().next().value;
    if (oldest === undefined) break;
    entries.delete(oldest);
  }
}
export function clearPublicHistory(): void { entries.clear(); }